import { Box, CircularProgress } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { AuctionProvider, useAuction } from '../../Contexts'
import { QuadkeyHeader } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'
import CompletedView from './CompletedView'
import QuadkeyFamilyPage from './Family'
import LiveView from './LiveView'
import QuadView from './QuadView'

interface DetailsProps {
  quadkey: Quadkey
}

const Details: React.FC<DetailsProps> = (props) => {
  const { quadkey } = props
  const { auction } = useAuction(quadkey)
  if (auction) {
    return (
      <Box alignItems="center" display="flex" flexDirection="column" flexGrow={1} justifyContent="center">
        <Box alignItems="center" display="flex" justifyContent="center" minHeight="80vmin" minWidth="80vmin">
          {auction.isLive() ? <LiveView /> : null}
          {auction.isDutch() ? <LiveView /> : null}
          {auction.isCompleted() ? <CompletedView quadkey={quadkey} /> : null}
          {auction.isUpcoming() ? <LiveView /> : null}
          {auction.isMinted() ? <QuadView /> : null}
        </Box>
      </Box>
    )
  }
  return (
    <Box alignItems="center" display="flex" flexDirection="column" flexGrow={1} justifyContent="center" minHeight="80vmin">
      <CircularProgress />
    </Box>
  )
}

const QuadkeyPage: React.FC = () => {
  const { id } = useParams()
  const quadkeyRequested = Quadkey.fromBase4String(id) ?? Quadkey.root

  return (
    <AuctionProvider quadkey={quadkeyRequested}>
      <WorldBasePage>
        <Helmet title="Quadkey Details" />
        <QuadkeyHeader quadkey={quadkeyRequested} />
        <Details quadkey={quadkeyRequested} />
      </WorldBasePage>
    </AuctionProvider>
  )
}

export { QuadkeyFamilyPage, QuadkeyPage, QuadView }
